module.exports = __webpack_public_path__ + "img/GVC001.6a553fee.png";